var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-timer"},[_c('span',{staticClass:"base-timer__label"},[_vm._v(_vm._s(_vm.formattedTimeLeft))])])}
var staticRenderFns = []

export { render, staticRenderFns }